interface CheckBalanceParams {
  formatted?: string;
  amountInUSD?: string;
  activeTabLabel: string;
  handleError: (message: string, error: any) => void;
  setIsLoading: (loading: boolean) => void;
}

export const checkBalance = ({
  formatted,
  amountInUSD,
  activeTabLabel,
  handleError,
  setIsLoading,
}: CheckBalanceParams): boolean => {
  const balanceFormatted = formatted ? parseFloat(formatted) : 0;

  if (balanceFormatted < Number(amountInUSD)) {
    handleError(
      `Insufficient balance. You need at least ${amountInUSD} ${activeTabLabel}.`,
      null
    );
    console.error(
      `Insufficient balance. You need at least ${amountInUSD} ${activeTabLabel}.`
    );
    setIsLoading(false);
    return false;
  }

  return true;
};
